// extracted by mini-css-extract-plugin
export default {"wrapper":"mainLayout_wrapper__GkJsy"};